import React from 'react';
import PropTypes from 'prop-types';
import {Flex, Text, Box} from '@spothero/ui';

const VehicleDisplay = ({make, model, plate, hideMakeModel = false}) => {
    return (
        // min-width  important for flex + truncated text https://css-tricks.com/flexbox-truncated-text/
        <Flex minWidth={0}>
            {!hideMakeModel && (
                <>
                    <Text
                        overflow="hidden"
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                        lineHeight="1.4"
                        data-testid="VehicleDisplay-text-makemodel"
                    >
                        {make ? `${make} ${model}` : 'Missing Vehicle'}
                    </Text>
                    <Box
                        marginX={2}
                        borderRightWidth="1px"
                        borderColor="gray.100"
                    />
                </>
            )}
            <Text
                lineHeight="1.4"
                whiteSpace="nowrap"
                data-testid="VehicleDisplay-text-plate"
            >
                {plate ? plate : 'Missing License Plate'}
            </Text>
        </Flex>
    );
};

VehicleDisplay.propTypes = {
    make: PropTypes.string,
    model: PropTypes.string,
    plate: PropTypes.string.isRequired,
    hideMakeModel: PropTypes.bool,
};

export default VehicleDisplay;
